import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SnackbarService } from '../../../services/snackbar.service';
import { SpinnerService } from '../../../services/spinner.service';
import {
  AdheridosPrevisionResiduosControllerService,
  GestoresResiduosControllerService,
  PageDTOGestoresResiduosDTO,
  PrevisionResiduosAdheridoPayloadDTO,
} from 'api-rest';
import { ValidateService } from '../../../services/validate.service';
import { Adherido } from '../../../models/adherido';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';

@Component({
  selector: 'app-waste-forecast-duplicate-dialog',
  templateUrl: './waste-forecast-duplicate-dialog.component.html',
  styleUrls: ['./waste-forecast-duplicate-dialog.component.scss'],
})
export class WasteForecastDuplicateDialogComponent implements OnInit {
  formGroup!: FormGroup;
  suministraInfoList = [
    { id: 'Gestor', name: 'Gestor' },
    { id: 'Adherido', name: 'Adherido' },
  ];
  anios: any[] = [];
  codigosLerEndpoint =
    this.environment.urlBackCore + 'api/v1/core/codigo-ler/filtro-combo?sddrCC=true';
  updateList: boolean = false;
  flagDisabledForm: boolean = false;
  anioActual!: number;
  savingData: boolean = false;
  label: string = 'Añadir previsión';

  constructor(
    private formBuilder: FormBuilder,
    @Inject('environment') private environment: any,
    public spinnerSrv: SpinnerService,
    private snackBarSrv: SnackbarService,
    private validateSrv: ValidateService,
    private gestoresResiduosControllerService: GestoresResiduosControllerService,
    private adheridosPrevisionResiduosControllerService: AdheridosPrevisionResiduosControllerService,
    @Inject('EmpusaAuthenticationService')
    public authService: EmpusaAuthenticationService | any,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      prevision: any;
      duplicar?: boolean;
      editar?: boolean;
      nueva?: boolean;
      adheridoInfo: Adherido;
      previsiones: any[];
    },
    public dialogRef: MatDialogRef<WasteForecastDuplicateDialogComponent>
  ) {
    this.formGroup = this.formBuilder.group({
      anio: [
        {
          value: this.data.prevision ? this.data.prevision?.anioDatos : null,
          disabled: this.data.editar ? true : false,
        },
        { validators: Validators.compose([Validators.required]) },
      ],
      codigoLer: [
        { value: this.data.prevision ? this.data.prevision?.codigoLer : null, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],
      nima: [
        { value: this.data.prevision ? this.data.prevision?.nimaGestor : null, disabled: false },
        {
          validators: Validators.compose([
            Validators.required,
            Validators.pattern(this.validateSrv.nimaPattern),
            Validators.maxLength(10),
          ]),
        },
      ],
      suministraInfo: [
        {
          value: this.data.prevision ? this.data.prevision?.suministradorInformacion : null,
          disabled: false,
        },
        { validators: Validators.compose([Validators.required]) },
      ],
    });
  }

  ngOnInit(): void {
    this.anioActual = new Date().getFullYear();
    // El gestor de envalora puede asignar el año actual, el anterior y el siguiente.
    // El adherido solo puede asignar el año actual y el siguiente.
    const anioMinimo = this.canViewResource('PO-ENV-GEST')
      ? this.anioActual - 1
      : this.anioActual;
    for (let i = anioMinimo; i <= this.anioActual + 1; i++) {
      this.anios.push({ id: i });
    }

    if (this.data.editar) {
      this.label = 'Editar previsión';
    } else if (this.data.duplicar) {
      this.label = 'Duplicar previsión';
    } else {
      this.label = 'Añadir previsión';
    }
  }

  getLerDescription(ler: any) {
    if (!ler || (!ler.tipoCodigo && !ler.descripcion && !ler.id)) return '';
    return (ler.tipoCodigo ?? '') + ' - ' + (ler.descripcion ?? '');
  }

  canViewResource(rol: string): boolean {
    return this.authService.hasCurrentUserRole(rol);
  }

  getFormControl(selectForm: any): FormControl {
    switch (selectForm) {
      case 'codigoLer': {
        return this.formGroup.get('codigoLer') as FormControl;
      }
      default: {
        return this.formGroup.get('') as FormControl;
      }
    }
  }

  getObjectQuery(searchterm: string) {
    return {
      descripcion: searchterm,
    };
  }

  public rightHolder(controlName: string) {
    let cl2 = '';
    if (
      (this.formGroup.controls[controlName]?.touched ||
        this.formGroup.controls[controlName]?.dirty) &&
      this.formGroup.controls[controlName]?.errors
    ) {
      cl2 = 'error-focus-input';
    } else {
      cl2 = 'success-focus-input';
    }
    return `${cl2}`;
  }

  selPaginatorHasError(controlName: string) {
    if (
      (this.formGroup.controls[controlName]?.touched ||
        this.formGroup.controls[controlName]?.dirty) &&
      this.formGroup.controls[controlName]?.errors
    ) {
      return true;
    } else {
      return false;
    }
  }

  controlHasError(controlName: string, errorName: string) {
    return (
      this.formGroup.controls[controlName].hasError(errorName) &&
      this.formGroup.controls[controlName].touched
    );
  }

  onInput(controlName: string, event: any) {
    const control = this.formGroup.get(controlName);
    control?.markAsTouched();
    control?.markAsDirty();
  }

  closeDialog() {
    this.dialogRef.close();
  }

  addPrevision(): void {
    if (this.formGroup.invalid) {
      this.formGroup.markAllAsTouched();
      this.snackBarSrv.showSnackBar('Revisar los errores en los campos ', 'error');
      return;
    }

    if (this.savingData) {
      return;
    }
    this.savingData = true;

    const existe = this.data.previsiones?.find(
      (x: any) =>
        x.anioDatos === this.formGroup.get('anio')?.value &&
        x.codigoLer?.id === this.formGroup.get('codigoLer')?.value?.id &&
        x.nimaGestor === this.formGroup.get('nima')?.value &&
        x.suministradorInformacion === this.formGroup.get('suministraInfo')?.value &&
        (!this.data.editar || x.id !== this.data.prevision?.id)
    );

    if (existe) {
      this.snackBarSrv.showSnackBar(
        'Ya existe una previsión de residuos generados en el SDDR Cerrado introducida',
        'error'
      );
      this.savingData = false;
      return;
    }

    const obj: PrevisionResiduosAdheridoPayloadDTO = {
      anioDatos: this.formGroup.get('anio')?.value,
      codigoLer: { id: this.formGroup.get('codigoLer')?.value?.id },
      nimaGestor: this.formGroup.get('nima')?.value,
      suministradorInformacion: this.formGroup.get('suministraInfo')?.value,
      adherido: { id: this.data.adheridoInfo.id! },
    };

    if (this.data.editar) {
      // Es necesario informar el id para que el backend actualice el registro existente
      // en lugar de perder su identificador al mapear el payload sobre la entidad.
      obj.id = this.data.prevision.id;
      this.editarPrevision(obj);
    } else {
      this.guardarPrevision(obj);
    }
  }

  guardarPrevision(residuo: PrevisionResiduosAdheridoPayloadDTO): void {
    this.spinnerSrv.loadingShow();
    this.adheridosPrevisionResiduosControllerService.create3(residuo).subscribe({
      next: () => {
        this.spinnerSrv.loadingHide();
        this.comprobarNima(residuo.nimaGestor);
      },
      error: (err) => this.onSaveError(err),
    });
  }

  private onSaveError(err: any): void {
    this.savingData = false;
    this.spinnerSrv.loadingHide();
    const msg =
      err?.status === 409
        ? 'Ya existe una previsión de residuos generados en el SDDR Cerrado introducida'
        : 'Ha ocurrido un error al guardar la previsión de residuos';
    this.snackBarSrv.showSnackBar(msg, 'error');
  }

  editarPrevision(residuo: PrevisionResiduosAdheridoPayloadDTO): void {
    this.spinnerSrv.loadingShow();
    this.adheridosPrevisionResiduosControllerService
      .editById3(this.data.prevision.id, residuo)
      .subscribe({
        next: () => {
          this.spinnerSrv.loadingHide();
          this.comprobarNima(residuo.nimaGestor, true);
        },
        error: (err) => this.onSaveError(err),
      });
  }

  private comprobarNima(nima: string, editado: boolean = false) {
    this.gestoresResiduosControllerService
      .findAll8({ nima: [nima] }, { page: 0, size: 10 })
      .subscribe({
        next: (data: PageDTOGestoresResiduosDTO) => {
          if (data && (data.datos?.length ?? 0) === 0) {
            this.snackBarSrv.showSnackBar(
              'Este gestor no está registrado en ENVANET. Le recomendamos que le informe de que debe registrarse, en caso de delegarle el suministro de información por la correcta gestión de sus envases.',
              'warning'
            );
          } else {
            this.snackBarSrv.showSnackBar(
              editado ? 'Se ha editado correctamente.' : 'Se ha creado correctamente.',
              'success'
            );
          }
          this.savingData = false;
          this.dialogRef.close(true);
        },
        error: () => {
          this.savingData = false;
          this.dialogRef.close(true);
        },
      });
  }
}
